import { useEffect, useState } from "react";

const useRevamp = () => {
  const [isRevamp, setIsRevamp] = useState<boolean>(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("isRevamp");
      if(stored){
        setIsRevamp(stored === "true");
      }
    }
  }, []);
  return { isRevamp };
};

export default useRevamp;
